import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';
import { BlockInputField } from '../../../../components/FormElements';

export const SpecialCodes = styled.div`
  width: 100%;
  max-width: 220px;
  padding-bottom: 10px;
  ${media.md`
    padding: 0 10px;
  `}
`;

export const StyledTextInput = styled(BlockInputField)`
  padding: 16px 0 16px 10px;

  ${media.md`
    padding: 11px 10px;
  `}
`;
